/**
 * Search Overlay Module
 * Handles the fullscreen search overlay functionality
 */

export class SearchOverlay {
  private overlay: HTMLElement | null;
  private closeButton: HTMLElement | null;
  private searchInput: HTMLInputElement | null;
  private searchTriggers: NodeListOf<HTMLElement>;
  private isOpen: boolean = false;

  constructor() {
    this.overlay = document.getElementById('search-overlay');
    this.closeButton = document.getElementById('search-close');
    this.searchInput = document.getElementById('search-overlay-field') as HTMLInputElement;
    this.searchTriggers = document.querySelectorAll('[data-search-trigger]');

    this.init();
  }

  private init(): void {
    if (!this.overlay) return;

    // Bind event listeners
    this.searchTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    this.closeButton?.addEventListener('click', () => this.close());

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Close when clicking outside the form
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });
  }

  private open(): void {
    if (!this.overlay) return;

    this.isOpen = true;
    this.overlay.classList.remove('opacity-0', 'invisible');
    this.overlay.classList.add('opacity-100', 'visible');
    
    // Focus the search input
    setTimeout(() => {
      this.searchInput?.focus();
    }, 300);

    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  private close(): void {
    if (!this.overlay) return;

    this.isOpen = false;
    this.overlay.classList.remove('opacity-100', 'visible');
    this.overlay.classList.add('opacity-0', 'invisible');
    
    // Clear search input
    if (this.searchInput) {
      this.searchInput.value = '';
    }

    // Restore body scroll
    document.body.style.overflow = '';
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SearchOverlay();
});